'use client'
import { useClientBootstrapInit, StatsigProvider } from '@statsig/react-bindings'
import { PropsWithChildren } from 'react'

import { useStatsigConsentSync } from './statsig-consent.hook'
import { getStatsigOptions } from './statsig-provider.utils'
import { StatsigUserAwareProvider } from './statsig-user-aware'
import { StatsigServerProps } from './statsig.types'

export function StatsigServerProvider({
  statsigServerProps,
  children,
  pageOptions,
}: PropsWithChildren<{
  statsigServerProps: StatsigServerProps
  pageOptions: {
    pageType: string | undefined
  }
}>) {
  const { key, data, serverSideExperiments, statsigUser } = statsigServerProps
  const client = useClientBootstrapInit(key, statsigUser, data, getStatsigOptions())
  useStatsigConsentSync(client, statsigUser)
  return (
    <StatsigProvider client={client}>
      <StatsigUserAwareProvider serverSideExperiments={serverSideExperiments} pageOptions={pageOptions}>
        {children}
      </StatsigUserAwareProvider>
    </StatsigProvider>
  )
}
